<template>
  <UBreadcrumb :items="links" class="my-2 hidden md:block">
    <template #separator>
      <span class="w-6 h-1 rounded-full bg-neutral-300 dark:bg-neutral-700" />
    </template>
    <template #default="{ link, isActive, index }">
      <p
        :class="
          isActive
            ? 'text-neutral-500 dark:text-neutral-400 hover:text-neutral-600 hover:dark:text-neutral-300'
            : 'text-neutral-400 dark:text-neutral-500 hover:text-neutral-500 hover:dark:text-neutral-400'
        "
      >
        {{ index + 1 }}. {{ link.label }}
      </p>
    </template>
  </UBreadcrumb>
  <UButton
    color="neutral"
    variant="link"
    icon="i-heroicons-chevron-left-16-solid"
    class="flex md:hidden"
    :to="previousLink.to"
    >{{ previousLink.label }}</UButton
  >
</template>

<script setup>
const props = defineProps({
  links: {
    type: Array,
    default: () => [],
  },
});

const previousLink = computed(() => props.links[props.links.length - 2]);
</script>
